// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: stateful_api.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AnalysisTreeGenerationRules_NodeInheritanceRules,
  AnalysisTreeNodeProto,
  AnalysisTreeProto,
  CommentaryProto,
  CommentaryProto_CommentaryConfig,
  InsightsProto,
  TreeNodeMetricProto,
} from "./analysis";
import { AnalysisPlanProto, ObservationEditProto } from "./analysis_plan";
import { BenchmarkProto, FilterProto, Header } from "./metadata";

export const protobufPackage = "com.meritic.newton.server";

/**
 * Type of stateful request. This corresponds to the application for which
 * statefulness is required and implemented in the system.
 */
export enum StatefulRequestType {
  INVALID_REQUEST_TYPE = 0,
  OBSERVATION_REQUEST = 1,
  ANALYSIS_TREE_REQUEST = 2,
  TISA_REQUEST = 3,
  UNRECOGNIZED = -1,
}

export function statefulRequestTypeFromJSON(object: any): StatefulRequestType {
  switch (object) {
    case 0:
    case "INVALID_REQUEST_TYPE":
      return StatefulRequestType.INVALID_REQUEST_TYPE;
    case 1:
    case "OBSERVATION_REQUEST":
      return StatefulRequestType.OBSERVATION_REQUEST;
    case 2:
    case "ANALYSIS_TREE_REQUEST":
      return StatefulRequestType.ANALYSIS_TREE_REQUEST;
    case 3:
    case "TISA_REQUEST":
      return StatefulRequestType.TISA_REQUEST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StatefulRequestType.UNRECOGNIZED;
  }
}

export function statefulRequestTypeToJSON(object: StatefulRequestType): string {
  switch (object) {
    case StatefulRequestType.INVALID_REQUEST_TYPE:
      return "INVALID_REQUEST_TYPE";
    case StatefulRequestType.OBSERVATION_REQUEST:
      return "OBSERVATION_REQUEST";
    case StatefulRequestType.ANALYSIS_TREE_REQUEST:
      return "ANALYSIS_TREE_REQUEST";
    case StatefulRequestType.TISA_REQUEST:
      return "TISA_REQUEST";
    case StatefulRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Types of requests available for analysis tree. */
export enum AnalysisTreeRequestType {
  INVALID_TREE_REQUEST = 0,
  GENERATE_TREE = 1,
  LOAD_TREE = 2,
  GET_TREE = 3,
  SAVE_TREE = 4,
  GENERATE_SUB_TREE = 5,
  GET_ANALYSIS_NODE = 6,
  SAVE_COMMENTARY = 8,
  DELETE_COMMENTARY = 9,
  UPDATE_TREE_HEADER = 10,
  SET_COMMENTARY = 11,
  UPDATE_NODE = 12,
  SET_INSIGHTS = 13,
  /** GENERATE_COMMENTARY - ======================== DEPRECATED REQUEST TYPES ======================== */
  GENERATE_COMMENTARY = 7,
  UNRECOGNIZED = -1,
}

export function analysisTreeRequestTypeFromJSON(object: any): AnalysisTreeRequestType {
  switch (object) {
    case 0:
    case "INVALID_TREE_REQUEST":
      return AnalysisTreeRequestType.INVALID_TREE_REQUEST;
    case 1:
    case "GENERATE_TREE":
      return AnalysisTreeRequestType.GENERATE_TREE;
    case 2:
    case "LOAD_TREE":
      return AnalysisTreeRequestType.LOAD_TREE;
    case 3:
    case "GET_TREE":
      return AnalysisTreeRequestType.GET_TREE;
    case 4:
    case "SAVE_TREE":
      return AnalysisTreeRequestType.SAVE_TREE;
    case 5:
    case "GENERATE_SUB_TREE":
      return AnalysisTreeRequestType.GENERATE_SUB_TREE;
    case 6:
    case "GET_ANALYSIS_NODE":
      return AnalysisTreeRequestType.GET_ANALYSIS_NODE;
    case 8:
    case "SAVE_COMMENTARY":
      return AnalysisTreeRequestType.SAVE_COMMENTARY;
    case 9:
    case "DELETE_COMMENTARY":
      return AnalysisTreeRequestType.DELETE_COMMENTARY;
    case 10:
    case "UPDATE_TREE_HEADER":
      return AnalysisTreeRequestType.UPDATE_TREE_HEADER;
    case 11:
    case "SET_COMMENTARY":
      return AnalysisTreeRequestType.SET_COMMENTARY;
    case 12:
    case "UPDATE_NODE":
      return AnalysisTreeRequestType.UPDATE_NODE;
    case 13:
    case "SET_INSIGHTS":
      return AnalysisTreeRequestType.SET_INSIGHTS;
    case 7:
    case "GENERATE_COMMENTARY":
      return AnalysisTreeRequestType.GENERATE_COMMENTARY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AnalysisTreeRequestType.UNRECOGNIZED;
  }
}

export function analysisTreeRequestTypeToJSON(object: AnalysisTreeRequestType): string {
  switch (object) {
    case AnalysisTreeRequestType.INVALID_TREE_REQUEST:
      return "INVALID_TREE_REQUEST";
    case AnalysisTreeRequestType.GENERATE_TREE:
      return "GENERATE_TREE";
    case AnalysisTreeRequestType.LOAD_TREE:
      return "LOAD_TREE";
    case AnalysisTreeRequestType.GET_TREE:
      return "GET_TREE";
    case AnalysisTreeRequestType.SAVE_TREE:
      return "SAVE_TREE";
    case AnalysisTreeRequestType.GENERATE_SUB_TREE:
      return "GENERATE_SUB_TREE";
    case AnalysisTreeRequestType.GET_ANALYSIS_NODE:
      return "GET_ANALYSIS_NODE";
    case AnalysisTreeRequestType.SAVE_COMMENTARY:
      return "SAVE_COMMENTARY";
    case AnalysisTreeRequestType.DELETE_COMMENTARY:
      return "DELETE_COMMENTARY";
    case AnalysisTreeRequestType.UPDATE_TREE_HEADER:
      return "UPDATE_TREE_HEADER";
    case AnalysisTreeRequestType.SET_COMMENTARY:
      return "SET_COMMENTARY";
    case AnalysisTreeRequestType.UPDATE_NODE:
      return "UPDATE_NODE";
    case AnalysisTreeRequestType.SET_INSIGHTS:
      return "SET_INSIGHTS";
    case AnalysisTreeRequestType.GENERATE_COMMENTARY:
      return "GENERATE_COMMENTARY";
    case AnalysisTreeRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of requests available for Tisa. */
export enum TisaRequestType {
  INVALID_TISA_REQUEST = 0,
  ADD_TREES = 1,
  REMOVE_TREES = 2,
  GET_TISA_STATE = 3,
  LOAD_TREES = 4,
  UNRECOGNIZED = -1,
}

export function tisaRequestTypeFromJSON(object: any): TisaRequestType {
  switch (object) {
    case 0:
    case "INVALID_TISA_REQUEST":
      return TisaRequestType.INVALID_TISA_REQUEST;
    case 1:
    case "ADD_TREES":
      return TisaRequestType.ADD_TREES;
    case 2:
    case "REMOVE_TREES":
      return TisaRequestType.REMOVE_TREES;
    case 3:
    case "GET_TISA_STATE":
      return TisaRequestType.GET_TISA_STATE;
    case 4:
    case "LOAD_TREES":
      return TisaRequestType.LOAD_TREES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TisaRequestType.UNRECOGNIZED;
  }
}

export function tisaRequestTypeToJSON(object: TisaRequestType): string {
  switch (object) {
    case TisaRequestType.INVALID_TISA_REQUEST:
      return "INVALID_TISA_REQUEST";
    case TisaRequestType.ADD_TREES:
      return "ADD_TREES";
    case TisaRequestType.REMOVE_TREES:
      return "REMOVE_TREES";
    case TisaRequestType.GET_TISA_STATE:
      return "GET_TISA_STATE";
    case TisaRequestType.LOAD_TREES:
      return "LOAD_TREES";
    case TisaRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** StateKey is the identifier used to get/put states in the stateful store. */
export interface StateKey {
  /**
   * Id of the transaction in the store which contains the stateful object
   * referenced by this key.
   */
  transaction_id?: string | undefined;
}

/** Key for referencing the analysis tree stateful session. */
export interface AnalysisTreeSessionKey {
  tree_id?: string | undefined;
  state_key?: StateKey | undefined;
}

/**
 * Common representation of a stateful request supported by the system.
 * @Path: /stateful
 * @Method: POST
 * @Consumes: application/json
 */
export interface StatefulRequest {
  request_type?:
    | StatefulRequestType
    | undefined;
  /**
   * Key to fetch the stateful object on which the request should be executed.
   * This should be a valid key, else the request will fail.
   */
  state_key?:
    | StateKey
    | undefined;
  /**
   * Analysis tree sessions that are active on the client side.
   * These sessions get set in the tisa state for the agent to use.
   * NOTE: Frida & Darwin both are clients for the agent state management.
   *       If user (frida) adds/removes a tree, then it should get reflected
   *       in agent state (darwin) also. And vice-versa is also true.
   */
  client_tree_sessions: AnalysisTreeSessionKey[];
  /**
   * Only one of the fields below should be set based on the type of request.
   * The requests are executed one-by-one in the same sequence as the order
   * of requests. If any one request fails, the entire stateful request fails.
   */
  analysis_tree_requests: StatefulAnalysisTreeRequest[];
  tisa_requests: StatefulTisaRequest[];
}

/** Common representation of the stateful response. */
export interface StatefulResponse {
  request_type?:
    | StatefulRequestType
    | undefined;
  /**
   * Key storing the stateful object after the execution of request.
   * This should be used to sent subsequent request on the same transaction.
   */
  state_key?:
    | StateKey
    | undefined;
  /**
   * List of all analysis tree sessions in the tisa session after all the
   * requests are executed.
   */
  analysis_tree_sessions: AnalysisTreeSessionKey[];
  /** Only one of the fields below should be set based on the type of request. */
  analysis_tree_responses: StatefulAnalysisTreeResponse[];
  tisa_response: StatefulTisaResponse[];
}

/**
 * Request to cancel the stateful transaction.
 * @Path: /stateful/cancel
 * @Method: POST
 * @Consumes: application/json
 */
export interface CancelRequest {
  /** Keys of the stateful transactions that should be cancelled/removed. */
  state_key: StateKey[];
}

export interface StatefulAnalysisTreeRequest {
  type?:
    | AnalysisTreeRequestType
    | undefined;
  /** Only one of the following requests will be set, based on the request type. */
  generate_tree?: GenerateTree_Request | undefined;
  load_tree?: LoadTree_Request | undefined;
  get_tree?: GetTree_Request | undefined;
  save_tree?: SaveTree_Request | undefined;
  generate_sub_tree?: GenerateSubTree_Request | undefined;
  get_analysis_node?: GetAnalysisNode_Request | undefined;
  save_commentary?: SaveCommentary_Request | undefined;
  delete_commentary?: DeleteCommentary_Request | undefined;
  update_tree_header?: UpdateTreeHeader_Request | undefined;
  set_commentary?: SetCommentary_Request | undefined;
  update_node?: UpdateNode_Request | undefined;
  set_insights?:
    | SetInsights_Request
    | undefined;
  /** ======================== DEPRECATED REQUESTS ======================== */
  generate_commentary?: GenerateCommentary_Request | undefined;
}

export interface StatefulAnalysisTreeResponse {
  type?:
    | AnalysisTreeRequestType
    | undefined;
  /** Only one of the following requests will be set, based on the request type. */
  generate_tree?: GenerateTree_Response | undefined;
  load_tree?: LoadTree_Response | undefined;
  get_tree?: GetTree_Response | undefined;
  save_tree?: SaveTree_Response | undefined;
  generate_sub_tree?: GenerateSubTree_Response | undefined;
  get_analysis_node?: GetAnalysisNode_Response | undefined;
  save_commentary?: SaveCommentary_Response | undefined;
  delete_commentary?: DeleteCommentary_Response | undefined;
  update_tree_header?: UpdateTreeHeader_Response | undefined;
  set_commentary?: SetCommentary_Response | undefined;
  update_node?: UpdateNode_Response | undefined;
  set_insights?:
    | SetInsights_Response
    | undefined;
  /** ======================== DEPRECATED RESPONSES ======================== */
  generate_commentary?: GenerateCommentary_Response | undefined;
}

/** Request response structures for generate analysis tree API. */
export interface GenerateTree {
}

export interface GenerateTree_Request {
  /** Id of the metric for which analysis tree will be generated. */
  metricId?:
    | string
    | undefined;
  /** Name for the analysis tree that is generated. */
  tree_name?:
    | string
    | undefined;
  /** Benchmarks to use for the analysis. */
  benchmark: BenchmarkProto[];
  /** List of context filters; */
  context: FilterProto[];
  /** List of mkg edges to exclude while generating analysis tree. */
  exclude_edges: Header[];
  /** Parameters to indicate when to switch to diagnostic analysis during tree generation. */
  diagnostic_plan?:
    | AnalysisTreeGenerationRules_NodeInheritanceRules
    | undefined;
  /** If analysis plan is set, use it to generate tree. */
  analysis_plan?: AnalysisPlanProto | undefined;
}

export interface GenerateTree_Response {
  /** Analysis tree generated for the given metric and context. */
  tree?:
    | AnalysisTreeProto
    | undefined;
  /** MKGs associated with each node in the tree along with recommendation edges. */
  node_metric_map: TreeNodeMetricProto[];
}

/** Request response structures to load an existing analysis tree in the stateful session. */
export interface LoadTree {
}

export interface LoadTree_Request {
  tree_id?: string | undefined;
}

export interface LoadTree_Response {
  /** Analysis tree with given id */
  tree?:
    | AnalysisTreeProto
    | undefined;
  /** MKGs associated with each node in the tree along with recommendation edges. */
  node_metric_map: TreeNodeMetricProto[];
}

/** Request response structures to get stateful analysis tree session information. */
export interface GetTree {
}

export interface GetTree_Request {
  /**
   * Boolean flag to indicate if tree nodes should be returned.
   * Default value is false.
   */
  include_nodes?:
    | boolean
    | undefined;
  /**
   * Boolean flag to indicate if commentaries in the session should be returned.
   * Default value is false.
   */
  include_commentary?:
    | boolean
    | undefined;
  /**
   * Boolean flag to indicate if MKGs associated with tree nodes should be returned.
   * Default value is false.
   */
  include_node_metric_map?: boolean | undefined;
}

export interface GetTree_Response {
  tree?:
    | AnalysisTreeProto
    | undefined;
  /** MKGs associated with each node in the tree along with recommendation edges. */
  node_metric_map: TreeNodeMetricProto[];
}

/** Request to save the analysis tree in stateful session. */
export interface SaveTree {
}

export interface SaveTree_Request {
}

export interface SaveTree_Response {
}

/**
 * Request use to update the analysis tree.
 * In the request, we will get node from which the further analysis need to be done
 * and the edge from the corresponding node to deep dive on that path.
 */
export interface GenerateSubTree {
}

export interface GenerateSubTree_Request {
  /**
   * Id of the analysis node which will be the parent of the root node in the subtree.
   * New child subtree will be created from this node.
   */
  parent_node_id?:
    | string
    | undefined;
  /** Id of the MKG edge to use to generate the child node (root node of subtree). */
  edge_id?:
    | string
    | undefined;
  /** Index of the data row which need to be analysed. */
  row_index?:
    | number
    | undefined;
  /**
   * Benchmark for the analysis.
   * New subtree at the root node (metric value analysis) will come from benchmark edges but
   * growth benchmarks are not present in the MKG. So for this case, we take growth benchmark
   * as input to generate the subtree.
   */
  benchmark?:
    | BenchmarkProto
    | undefined;
  /**
   * Boolean flag to indicate if only the root node (child of parent node) should be created.
   * Default value is false, i.e., the whole subtree will be created.
   */
  create_root_node_only?:
    | boolean
    | undefined;
  /** List of observation edits of child step. */
  child_step_edits: ObservationEditProto[];
}

export interface GenerateSubTree_Response {
}

/** Request used to get an analysis node from the tree present in stateful session. */
export interface GetAnalysisNode {
}

export interface GetAnalysisNode_Request {
  node_id?:
    | string
    | undefined;
  /**
   * Boolean flag to indicate if the analysed data should also be included.
   * Default value is false.
   */
  include_data?:
    | boolean
    | undefined;
  /**
   * Boolean flag to indicate if the parent kg observation should also be included.
   * Default value is false.
   */
  include_parent_kg_observation?: boolean | undefined;
}

export interface GetAnalysisNode_Response {
  analysis_node?: AnalysisTreeNodeProto | undefined;
}

/** Request used to set commentary in the tree state. */
export interface SetCommentary {
}

export interface SetCommentary_Request {
  commentary: CommentaryProto[];
}

export interface SetCommentary_Response {
}

/** Request used to save commentary. */
export interface SaveCommentary {
}

export interface SaveCommentary_Request {
  /**
   * Id of the conversation in stateful session to save.
   * Also saves the analysis tree, if its not saved already.
   */
  conversation_id?:
    | string
    | undefined;
  /** User-edited commentary to save. If this is not set, then save the original commentary. */
  edited_commentary?: string | undefined;
}

export interface SaveCommentary_Response {
}

/**
 * Request used to delete a commentary for the analysis tree.
 * Deletes the commentary from tree repository, and removes it from the session (if requested).
 */
export interface DeleteCommentary {
}

export interface DeleteCommentary_Request {
  /** Id of the conversation to delete. */
  conversation_id?:
    | string
    | undefined;
  /**
   * Flag to indicate if the commentary should be removed from session as well.
   * Default value is false.
   */
  remove_from_session?: boolean | undefined;
}

export interface DeleteCommentary_Response {
}

/** Request used to update tree header. */
export interface UpdateTreeHeader {
}

export interface UpdateTreeHeader_Request {
  /** Name of the tree. */
  updated_name?:
    | string
    | undefined;
  /** Description of the tree. */
  updated_description?: string | undefined;
}

export interface UpdateTreeHeader_Response {
}

/** Request used to update node label. */
export interface UpdateNode {
}

export interface UpdateNode_Request {
  /** Id of the node. */
  node_id?:
    | string
    | undefined;
  /** Updated label of node. */
  new_node_label?: string | undefined;
}

export interface UpdateNode_Response {
}

/** Request used to set insights in the tree state. */
export interface SetInsights {
}

export interface SetInsights_Request {
  insights: InsightsProto[];
}

export interface SetInsights_Response {
}

export interface StatefulTisaRequest {
  type?:
    | TisaRequestType
    | undefined;
  /** Only one of the following requests will be set, based on the request type. */
  add_trees?: AddTrees_Request | undefined;
  remove_trees?: RemoveTrees_Request | undefined;
  get_tisa_state?: GetTisaState_Request | undefined;
  load_trees?: LoadTrees_Request | undefined;
}

export interface StatefulTisaResponse {
  type?:
    | TisaRequestType
    | undefined;
  /** Only one of the following requests will be set, based on the request type. */
  add_trees?: AddTrees_Response | undefined;
  remove_trees?: RemoveTrees_Response | undefined;
  get_tisa_state?: GetTisaState_Response | undefined;
  load_trees?: LoadTrees_Response | undefined;
}

export interface AddTrees {
}

export interface AddTrees_Request {
  tree_ids: string[];
}

export interface AddTrees_Response {
}

export interface RemoveTrees {
}

export interface RemoveTrees_Request {
  tree_ids: string[];
}

export interface RemoveTrees_Response {
}

export interface GetTisaState {
}

export interface GetTisaState_Request {
  include_tree_sessions?: boolean | undefined;
  include_trees?: boolean | undefined;
}

export interface GetTisaState_Response {
  trees: AnalysisTreeProto[];
  tree_sessions: AnalysisTreeSessionKey[];
}

export interface LoadTrees {
}

export interface LoadTrees_Request {
  tree_ids: string[];
}

export interface LoadTrees_Response {
}

/** Request used to generate commentary. */
export interface GenerateCommentary {
}

export interface GenerateCommentary_Request {
  /** Configuration used to generate the commentary. */
  configuration?: CommentaryProto_CommentaryConfig | undefined;
}

export interface GenerateCommentary_Response {
  commentary?: CommentaryProto | undefined;
}

function createBaseStateKey(): StateKey {
  return { transaction_id: undefined };
}

export const StateKey: MessageFns<StateKey> = {
  encode(message: StateKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.transaction_id !== undefined) {
      writer.uint32(10).string(message.transaction_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StateKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStateKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.transaction_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StateKey {
    return { transaction_id: isSet(object.transaction_id) ? globalThis.String(object.transaction_id) : undefined };
  },

  toJSON(message: StateKey): unknown {
    const obj: any = {};
    if (message.transaction_id !== undefined) {
      obj.transaction_id = message.transaction_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StateKey>, I>>(base?: I): StateKey {
    return StateKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StateKey>, I>>(object: I): StateKey {
    const message = createBaseStateKey();
    message.transaction_id = object.transaction_id ?? undefined;
    return message;
  },
};

function createBaseAnalysisTreeSessionKey(): AnalysisTreeSessionKey {
  return { tree_id: undefined, state_key: undefined };
}

export const AnalysisTreeSessionKey: MessageFns<AnalysisTreeSessionKey> = {
  encode(message: AnalysisTreeSessionKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree_id !== undefined) {
      writer.uint32(10).string(message.tree_id);
    }
    if (message.state_key !== undefined) {
      StateKey.encode(message.state_key, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeSessionKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeSessionKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state_key = StateKey.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeSessionKey {
    return {
      tree_id: isSet(object.tree_id) ? globalThis.String(object.tree_id) : undefined,
      state_key: isSet(object.state_key) ? StateKey.fromJSON(object.state_key) : undefined,
    };
  },

  toJSON(message: AnalysisTreeSessionKey): unknown {
    const obj: any = {};
    if (message.tree_id !== undefined) {
      obj.tree_id = message.tree_id;
    }
    if (message.state_key !== undefined) {
      obj.state_key = StateKey.toJSON(message.state_key);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeSessionKey>, I>>(base?: I): AnalysisTreeSessionKey {
    return AnalysisTreeSessionKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeSessionKey>, I>>(object: I): AnalysisTreeSessionKey {
    const message = createBaseAnalysisTreeSessionKey();
    message.tree_id = object.tree_id ?? undefined;
    message.state_key = (object.state_key !== undefined && object.state_key !== null)
      ? StateKey.fromPartial(object.state_key)
      : undefined;
    return message;
  },
};

function createBaseStatefulRequest(): StatefulRequest {
  return {
    request_type: undefined,
    state_key: undefined,
    client_tree_sessions: [],
    analysis_tree_requests: [],
    tisa_requests: [],
  };
}

export const StatefulRequest: MessageFns<StatefulRequest> = {
  encode(message: StatefulRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request_type !== undefined) {
      writer.uint32(8).int32(message.request_type);
    }
    if (message.state_key !== undefined) {
      StateKey.encode(message.state_key, writer.uint32(18).fork()).join();
    }
    for (const v of message.client_tree_sessions) {
      AnalysisTreeSessionKey.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.analysis_tree_requests) {
      StatefulAnalysisTreeRequest.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.tisa_requests) {
      StatefulTisaRequest.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.request_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state_key = StateKey.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.client_tree_sessions.push(AnalysisTreeSessionKey.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analysis_tree_requests.push(StatefulAnalysisTreeRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tisa_requests.push(StatefulTisaRequest.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulRequest {
    return {
      request_type: isSet(object.request_type) ? statefulRequestTypeFromJSON(object.request_type) : undefined,
      state_key: isSet(object.state_key) ? StateKey.fromJSON(object.state_key) : undefined,
      client_tree_sessions: globalThis.Array.isArray(object?.client_tree_sessions)
        ? object.client_tree_sessions.map((e: any) => AnalysisTreeSessionKey.fromJSON(e))
        : [],
      analysis_tree_requests: globalThis.Array.isArray(object?.analysis_tree_requests)
        ? object.analysis_tree_requests.map((e: any) => StatefulAnalysisTreeRequest.fromJSON(e))
        : [],
      tisa_requests: globalThis.Array.isArray(object?.tisa_requests)
        ? object.tisa_requests.map((e: any) => StatefulTisaRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StatefulRequest): unknown {
    const obj: any = {};
    if (message.request_type !== undefined) {
      obj.request_type = statefulRequestTypeToJSON(message.request_type);
    }
    if (message.state_key !== undefined) {
      obj.state_key = StateKey.toJSON(message.state_key);
    }
    if (message.client_tree_sessions?.length) {
      obj.client_tree_sessions = message.client_tree_sessions.map((e) => AnalysisTreeSessionKey.toJSON(e));
    }
    if (message.analysis_tree_requests?.length) {
      obj.analysis_tree_requests = message.analysis_tree_requests.map((e) => StatefulAnalysisTreeRequest.toJSON(e));
    }
    if (message.tisa_requests?.length) {
      obj.tisa_requests = message.tisa_requests.map((e) => StatefulTisaRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulRequest>, I>>(base?: I): StatefulRequest {
    return StatefulRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulRequest>, I>>(object: I): StatefulRequest {
    const message = createBaseStatefulRequest();
    message.request_type = object.request_type ?? undefined;
    message.state_key = (object.state_key !== undefined && object.state_key !== null)
      ? StateKey.fromPartial(object.state_key)
      : undefined;
    message.client_tree_sessions = object.client_tree_sessions?.map((e) => AnalysisTreeSessionKey.fromPartial(e)) || [];
    message.analysis_tree_requests =
      object.analysis_tree_requests?.map((e) => StatefulAnalysisTreeRequest.fromPartial(e)) || [];
    message.tisa_requests = object.tisa_requests?.map((e) => StatefulTisaRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStatefulResponse(): StatefulResponse {
  return {
    request_type: undefined,
    state_key: undefined,
    analysis_tree_sessions: [],
    analysis_tree_responses: [],
    tisa_response: [],
  };
}

export const StatefulResponse: MessageFns<StatefulResponse> = {
  encode(message: StatefulResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request_type !== undefined) {
      writer.uint32(8).int32(message.request_type);
    }
    if (message.state_key !== undefined) {
      StateKey.encode(message.state_key, writer.uint32(18).fork()).join();
    }
    for (const v of message.analysis_tree_sessions) {
      AnalysisTreeSessionKey.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.analysis_tree_responses) {
      StatefulAnalysisTreeResponse.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.tisa_response) {
      StatefulTisaResponse.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.request_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state_key = StateKey.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.analysis_tree_sessions.push(AnalysisTreeSessionKey.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analysis_tree_responses.push(StatefulAnalysisTreeResponse.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tisa_response.push(StatefulTisaResponse.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulResponse {
    return {
      request_type: isSet(object.request_type) ? statefulRequestTypeFromJSON(object.request_type) : undefined,
      state_key: isSet(object.state_key) ? StateKey.fromJSON(object.state_key) : undefined,
      analysis_tree_sessions: globalThis.Array.isArray(object?.analysis_tree_sessions)
        ? object.analysis_tree_sessions.map((e: any) => AnalysisTreeSessionKey.fromJSON(e))
        : [],
      analysis_tree_responses: globalThis.Array.isArray(object?.analysis_tree_responses)
        ? object.analysis_tree_responses.map((e: any) => StatefulAnalysisTreeResponse.fromJSON(e))
        : [],
      tisa_response: globalThis.Array.isArray(object?.tisa_response)
        ? object.tisa_response.map((e: any) => StatefulTisaResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StatefulResponse): unknown {
    const obj: any = {};
    if (message.request_type !== undefined) {
      obj.request_type = statefulRequestTypeToJSON(message.request_type);
    }
    if (message.state_key !== undefined) {
      obj.state_key = StateKey.toJSON(message.state_key);
    }
    if (message.analysis_tree_sessions?.length) {
      obj.analysis_tree_sessions = message.analysis_tree_sessions.map((e) => AnalysisTreeSessionKey.toJSON(e));
    }
    if (message.analysis_tree_responses?.length) {
      obj.analysis_tree_responses = message.analysis_tree_responses.map((e) => StatefulAnalysisTreeResponse.toJSON(e));
    }
    if (message.tisa_response?.length) {
      obj.tisa_response = message.tisa_response.map((e) => StatefulTisaResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulResponse>, I>>(base?: I): StatefulResponse {
    return StatefulResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulResponse>, I>>(object: I): StatefulResponse {
    const message = createBaseStatefulResponse();
    message.request_type = object.request_type ?? undefined;
    message.state_key = (object.state_key !== undefined && object.state_key !== null)
      ? StateKey.fromPartial(object.state_key)
      : undefined;
    message.analysis_tree_sessions = object.analysis_tree_sessions?.map((e) => AnalysisTreeSessionKey.fromPartial(e)) ||
      [];
    message.analysis_tree_responses =
      object.analysis_tree_responses?.map((e) => StatefulAnalysisTreeResponse.fromPartial(e)) || [];
    message.tisa_response = object.tisa_response?.map((e) => StatefulTisaResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCancelRequest(): CancelRequest {
  return { state_key: [] };
}

export const CancelRequest: MessageFns<CancelRequest> = {
  encode(message: CancelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.state_key) {
      StateKey.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.state_key.push(StateKey.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelRequest {
    return {
      state_key: globalThis.Array.isArray(object?.state_key)
        ? object.state_key.map((e: any) => StateKey.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CancelRequest): unknown {
    const obj: any = {};
    if (message.state_key?.length) {
      obj.state_key = message.state_key.map((e) => StateKey.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelRequest>, I>>(base?: I): CancelRequest {
    return CancelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelRequest>, I>>(object: I): CancelRequest {
    const message = createBaseCancelRequest();
    message.state_key = object.state_key?.map((e) => StateKey.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStatefulAnalysisTreeRequest(): StatefulAnalysisTreeRequest {
  return {
    type: undefined,
    generate_tree: undefined,
    load_tree: undefined,
    get_tree: undefined,
    save_tree: undefined,
    generate_sub_tree: undefined,
    get_analysis_node: undefined,
    save_commentary: undefined,
    delete_commentary: undefined,
    update_tree_header: undefined,
    set_commentary: undefined,
    update_node: undefined,
    set_insights: undefined,
    generate_commentary: undefined,
  };
}

export const StatefulAnalysisTreeRequest: MessageFns<StatefulAnalysisTreeRequest> = {
  encode(message: StatefulAnalysisTreeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.generate_tree !== undefined) {
      GenerateTree_Request.encode(message.generate_tree, writer.uint32(18).fork()).join();
    }
    if (message.load_tree !== undefined) {
      LoadTree_Request.encode(message.load_tree, writer.uint32(26).fork()).join();
    }
    if (message.get_tree !== undefined) {
      GetTree_Request.encode(message.get_tree, writer.uint32(34).fork()).join();
    }
    if (message.save_tree !== undefined) {
      SaveTree_Request.encode(message.save_tree, writer.uint32(42).fork()).join();
    }
    if (message.generate_sub_tree !== undefined) {
      GenerateSubTree_Request.encode(message.generate_sub_tree, writer.uint32(50).fork()).join();
    }
    if (message.get_analysis_node !== undefined) {
      GetAnalysisNode_Request.encode(message.get_analysis_node, writer.uint32(58).fork()).join();
    }
    if (message.save_commentary !== undefined) {
      SaveCommentary_Request.encode(message.save_commentary, writer.uint32(74).fork()).join();
    }
    if (message.delete_commentary !== undefined) {
      DeleteCommentary_Request.encode(message.delete_commentary, writer.uint32(82).fork()).join();
    }
    if (message.update_tree_header !== undefined) {
      UpdateTreeHeader_Request.encode(message.update_tree_header, writer.uint32(90).fork()).join();
    }
    if (message.set_commentary !== undefined) {
      SetCommentary_Request.encode(message.set_commentary, writer.uint32(98).fork()).join();
    }
    if (message.update_node !== undefined) {
      UpdateNode_Request.encode(message.update_node, writer.uint32(106).fork()).join();
    }
    if (message.set_insights !== undefined) {
      SetInsights_Request.encode(message.set_insights, writer.uint32(114).fork()).join();
    }
    if (message.generate_commentary !== undefined) {
      GenerateCommentary_Request.encode(message.generate_commentary, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulAnalysisTreeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulAnalysisTreeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.generate_tree = GenerateTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.load_tree = LoadTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.get_tree = GetTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.save_tree = SaveTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.generate_sub_tree = GenerateSubTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.get_analysis_node = GetAnalysisNode_Request.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.save_commentary = SaveCommentary_Request.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.delete_commentary = DeleteCommentary_Request.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.update_tree_header = UpdateTreeHeader_Request.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.set_commentary = SetCommentary_Request.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.update_node = UpdateNode_Request.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.set_insights = SetInsights_Request.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.generate_commentary = GenerateCommentary_Request.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulAnalysisTreeRequest {
    return {
      type: isSet(object.type) ? analysisTreeRequestTypeFromJSON(object.type) : undefined,
      generate_tree: isSet(object.generate_tree) ? GenerateTree_Request.fromJSON(object.generate_tree) : undefined,
      load_tree: isSet(object.load_tree) ? LoadTree_Request.fromJSON(object.load_tree) : undefined,
      get_tree: isSet(object.get_tree) ? GetTree_Request.fromJSON(object.get_tree) : undefined,
      save_tree: isSet(object.save_tree) ? SaveTree_Request.fromJSON(object.save_tree) : undefined,
      generate_sub_tree: isSet(object.generate_sub_tree)
        ? GenerateSubTree_Request.fromJSON(object.generate_sub_tree)
        : undefined,
      get_analysis_node: isSet(object.get_analysis_node)
        ? GetAnalysisNode_Request.fromJSON(object.get_analysis_node)
        : undefined,
      save_commentary: isSet(object.save_commentary)
        ? SaveCommentary_Request.fromJSON(object.save_commentary)
        : undefined,
      delete_commentary: isSet(object.delete_commentary)
        ? DeleteCommentary_Request.fromJSON(object.delete_commentary)
        : undefined,
      update_tree_header: isSet(object.update_tree_header)
        ? UpdateTreeHeader_Request.fromJSON(object.update_tree_header)
        : undefined,
      set_commentary: isSet(object.set_commentary) ? SetCommentary_Request.fromJSON(object.set_commentary) : undefined,
      update_node: isSet(object.update_node) ? UpdateNode_Request.fromJSON(object.update_node) : undefined,
      set_insights: isSet(object.set_insights) ? SetInsights_Request.fromJSON(object.set_insights) : undefined,
      generate_commentary: isSet(object.generate_commentary)
        ? GenerateCommentary_Request.fromJSON(object.generate_commentary)
        : undefined,
    };
  },

  toJSON(message: StatefulAnalysisTreeRequest): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = analysisTreeRequestTypeToJSON(message.type);
    }
    if (message.generate_tree !== undefined) {
      obj.generate_tree = GenerateTree_Request.toJSON(message.generate_tree);
    }
    if (message.load_tree !== undefined) {
      obj.load_tree = LoadTree_Request.toJSON(message.load_tree);
    }
    if (message.get_tree !== undefined) {
      obj.get_tree = GetTree_Request.toJSON(message.get_tree);
    }
    if (message.save_tree !== undefined) {
      obj.save_tree = SaveTree_Request.toJSON(message.save_tree);
    }
    if (message.generate_sub_tree !== undefined) {
      obj.generate_sub_tree = GenerateSubTree_Request.toJSON(message.generate_sub_tree);
    }
    if (message.get_analysis_node !== undefined) {
      obj.get_analysis_node = GetAnalysisNode_Request.toJSON(message.get_analysis_node);
    }
    if (message.save_commentary !== undefined) {
      obj.save_commentary = SaveCommentary_Request.toJSON(message.save_commentary);
    }
    if (message.delete_commentary !== undefined) {
      obj.delete_commentary = DeleteCommentary_Request.toJSON(message.delete_commentary);
    }
    if (message.update_tree_header !== undefined) {
      obj.update_tree_header = UpdateTreeHeader_Request.toJSON(message.update_tree_header);
    }
    if (message.set_commentary !== undefined) {
      obj.set_commentary = SetCommentary_Request.toJSON(message.set_commentary);
    }
    if (message.update_node !== undefined) {
      obj.update_node = UpdateNode_Request.toJSON(message.update_node);
    }
    if (message.set_insights !== undefined) {
      obj.set_insights = SetInsights_Request.toJSON(message.set_insights);
    }
    if (message.generate_commentary !== undefined) {
      obj.generate_commentary = GenerateCommentary_Request.toJSON(message.generate_commentary);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulAnalysisTreeRequest>, I>>(base?: I): StatefulAnalysisTreeRequest {
    return StatefulAnalysisTreeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulAnalysisTreeRequest>, I>>(object: I): StatefulAnalysisTreeRequest {
    const message = createBaseStatefulAnalysisTreeRequest();
    message.type = object.type ?? undefined;
    message.generate_tree = (object.generate_tree !== undefined && object.generate_tree !== null)
      ? GenerateTree_Request.fromPartial(object.generate_tree)
      : undefined;
    message.load_tree = (object.load_tree !== undefined && object.load_tree !== null)
      ? LoadTree_Request.fromPartial(object.load_tree)
      : undefined;
    message.get_tree = (object.get_tree !== undefined && object.get_tree !== null)
      ? GetTree_Request.fromPartial(object.get_tree)
      : undefined;
    message.save_tree = (object.save_tree !== undefined && object.save_tree !== null)
      ? SaveTree_Request.fromPartial(object.save_tree)
      : undefined;
    message.generate_sub_tree = (object.generate_sub_tree !== undefined && object.generate_sub_tree !== null)
      ? GenerateSubTree_Request.fromPartial(object.generate_sub_tree)
      : undefined;
    message.get_analysis_node = (object.get_analysis_node !== undefined && object.get_analysis_node !== null)
      ? GetAnalysisNode_Request.fromPartial(object.get_analysis_node)
      : undefined;
    message.save_commentary = (object.save_commentary !== undefined && object.save_commentary !== null)
      ? SaveCommentary_Request.fromPartial(object.save_commentary)
      : undefined;
    message.delete_commentary = (object.delete_commentary !== undefined && object.delete_commentary !== null)
      ? DeleteCommentary_Request.fromPartial(object.delete_commentary)
      : undefined;
    message.update_tree_header = (object.update_tree_header !== undefined && object.update_tree_header !== null)
      ? UpdateTreeHeader_Request.fromPartial(object.update_tree_header)
      : undefined;
    message.set_commentary = (object.set_commentary !== undefined && object.set_commentary !== null)
      ? SetCommentary_Request.fromPartial(object.set_commentary)
      : undefined;
    message.update_node = (object.update_node !== undefined && object.update_node !== null)
      ? UpdateNode_Request.fromPartial(object.update_node)
      : undefined;
    message.set_insights = (object.set_insights !== undefined && object.set_insights !== null)
      ? SetInsights_Request.fromPartial(object.set_insights)
      : undefined;
    message.generate_commentary = (object.generate_commentary !== undefined && object.generate_commentary !== null)
      ? GenerateCommentary_Request.fromPartial(object.generate_commentary)
      : undefined;
    return message;
  },
};

function createBaseStatefulAnalysisTreeResponse(): StatefulAnalysisTreeResponse {
  return {
    type: undefined,
    generate_tree: undefined,
    load_tree: undefined,
    get_tree: undefined,
    save_tree: undefined,
    generate_sub_tree: undefined,
    get_analysis_node: undefined,
    save_commentary: undefined,
    delete_commentary: undefined,
    update_tree_header: undefined,
    set_commentary: undefined,
    update_node: undefined,
    set_insights: undefined,
    generate_commentary: undefined,
  };
}

export const StatefulAnalysisTreeResponse: MessageFns<StatefulAnalysisTreeResponse> = {
  encode(message: StatefulAnalysisTreeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.generate_tree !== undefined) {
      GenerateTree_Response.encode(message.generate_tree, writer.uint32(18).fork()).join();
    }
    if (message.load_tree !== undefined) {
      LoadTree_Response.encode(message.load_tree, writer.uint32(26).fork()).join();
    }
    if (message.get_tree !== undefined) {
      GetTree_Response.encode(message.get_tree, writer.uint32(34).fork()).join();
    }
    if (message.save_tree !== undefined) {
      SaveTree_Response.encode(message.save_tree, writer.uint32(42).fork()).join();
    }
    if (message.generate_sub_tree !== undefined) {
      GenerateSubTree_Response.encode(message.generate_sub_tree, writer.uint32(50).fork()).join();
    }
    if (message.get_analysis_node !== undefined) {
      GetAnalysisNode_Response.encode(message.get_analysis_node, writer.uint32(58).fork()).join();
    }
    if (message.save_commentary !== undefined) {
      SaveCommentary_Response.encode(message.save_commentary, writer.uint32(74).fork()).join();
    }
    if (message.delete_commentary !== undefined) {
      DeleteCommentary_Response.encode(message.delete_commentary, writer.uint32(82).fork()).join();
    }
    if (message.update_tree_header !== undefined) {
      UpdateTreeHeader_Response.encode(message.update_tree_header, writer.uint32(90).fork()).join();
    }
    if (message.set_commentary !== undefined) {
      SetCommentary_Response.encode(message.set_commentary, writer.uint32(98).fork()).join();
    }
    if (message.update_node !== undefined) {
      UpdateNode_Response.encode(message.update_node, writer.uint32(106).fork()).join();
    }
    if (message.set_insights !== undefined) {
      SetInsights_Response.encode(message.set_insights, writer.uint32(114).fork()).join();
    }
    if (message.generate_commentary !== undefined) {
      GenerateCommentary_Response.encode(message.generate_commentary, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulAnalysisTreeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulAnalysisTreeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.generate_tree = GenerateTree_Response.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.load_tree = LoadTree_Response.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.get_tree = GetTree_Response.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.save_tree = SaveTree_Response.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.generate_sub_tree = GenerateSubTree_Response.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.get_analysis_node = GetAnalysisNode_Response.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.save_commentary = SaveCommentary_Response.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.delete_commentary = DeleteCommentary_Response.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.update_tree_header = UpdateTreeHeader_Response.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.set_commentary = SetCommentary_Response.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.update_node = UpdateNode_Response.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.set_insights = SetInsights_Response.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.generate_commentary = GenerateCommentary_Response.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulAnalysisTreeResponse {
    return {
      type: isSet(object.type) ? analysisTreeRequestTypeFromJSON(object.type) : undefined,
      generate_tree: isSet(object.generate_tree) ? GenerateTree_Response.fromJSON(object.generate_tree) : undefined,
      load_tree: isSet(object.load_tree) ? LoadTree_Response.fromJSON(object.load_tree) : undefined,
      get_tree: isSet(object.get_tree) ? GetTree_Response.fromJSON(object.get_tree) : undefined,
      save_tree: isSet(object.save_tree) ? SaveTree_Response.fromJSON(object.save_tree) : undefined,
      generate_sub_tree: isSet(object.generate_sub_tree)
        ? GenerateSubTree_Response.fromJSON(object.generate_sub_tree)
        : undefined,
      get_analysis_node: isSet(object.get_analysis_node)
        ? GetAnalysisNode_Response.fromJSON(object.get_analysis_node)
        : undefined,
      save_commentary: isSet(object.save_commentary)
        ? SaveCommentary_Response.fromJSON(object.save_commentary)
        : undefined,
      delete_commentary: isSet(object.delete_commentary)
        ? DeleteCommentary_Response.fromJSON(object.delete_commentary)
        : undefined,
      update_tree_header: isSet(object.update_tree_header)
        ? UpdateTreeHeader_Response.fromJSON(object.update_tree_header)
        : undefined,
      set_commentary: isSet(object.set_commentary) ? SetCommentary_Response.fromJSON(object.set_commentary) : undefined,
      update_node: isSet(object.update_node) ? UpdateNode_Response.fromJSON(object.update_node) : undefined,
      set_insights: isSet(object.set_insights) ? SetInsights_Response.fromJSON(object.set_insights) : undefined,
      generate_commentary: isSet(object.generate_commentary)
        ? GenerateCommentary_Response.fromJSON(object.generate_commentary)
        : undefined,
    };
  },

  toJSON(message: StatefulAnalysisTreeResponse): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = analysisTreeRequestTypeToJSON(message.type);
    }
    if (message.generate_tree !== undefined) {
      obj.generate_tree = GenerateTree_Response.toJSON(message.generate_tree);
    }
    if (message.load_tree !== undefined) {
      obj.load_tree = LoadTree_Response.toJSON(message.load_tree);
    }
    if (message.get_tree !== undefined) {
      obj.get_tree = GetTree_Response.toJSON(message.get_tree);
    }
    if (message.save_tree !== undefined) {
      obj.save_tree = SaveTree_Response.toJSON(message.save_tree);
    }
    if (message.generate_sub_tree !== undefined) {
      obj.generate_sub_tree = GenerateSubTree_Response.toJSON(message.generate_sub_tree);
    }
    if (message.get_analysis_node !== undefined) {
      obj.get_analysis_node = GetAnalysisNode_Response.toJSON(message.get_analysis_node);
    }
    if (message.save_commentary !== undefined) {
      obj.save_commentary = SaveCommentary_Response.toJSON(message.save_commentary);
    }
    if (message.delete_commentary !== undefined) {
      obj.delete_commentary = DeleteCommentary_Response.toJSON(message.delete_commentary);
    }
    if (message.update_tree_header !== undefined) {
      obj.update_tree_header = UpdateTreeHeader_Response.toJSON(message.update_tree_header);
    }
    if (message.set_commentary !== undefined) {
      obj.set_commentary = SetCommentary_Response.toJSON(message.set_commentary);
    }
    if (message.update_node !== undefined) {
      obj.update_node = UpdateNode_Response.toJSON(message.update_node);
    }
    if (message.set_insights !== undefined) {
      obj.set_insights = SetInsights_Response.toJSON(message.set_insights);
    }
    if (message.generate_commentary !== undefined) {
      obj.generate_commentary = GenerateCommentary_Response.toJSON(message.generate_commentary);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulAnalysisTreeResponse>, I>>(base?: I): StatefulAnalysisTreeResponse {
    return StatefulAnalysisTreeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulAnalysisTreeResponse>, I>>(object: I): StatefulAnalysisTreeResponse {
    const message = createBaseStatefulAnalysisTreeResponse();
    message.type = object.type ?? undefined;
    message.generate_tree = (object.generate_tree !== undefined && object.generate_tree !== null)
      ? GenerateTree_Response.fromPartial(object.generate_tree)
      : undefined;
    message.load_tree = (object.load_tree !== undefined && object.load_tree !== null)
      ? LoadTree_Response.fromPartial(object.load_tree)
      : undefined;
    message.get_tree = (object.get_tree !== undefined && object.get_tree !== null)
      ? GetTree_Response.fromPartial(object.get_tree)
      : undefined;
    message.save_tree = (object.save_tree !== undefined && object.save_tree !== null)
      ? SaveTree_Response.fromPartial(object.save_tree)
      : undefined;
    message.generate_sub_tree = (object.generate_sub_tree !== undefined && object.generate_sub_tree !== null)
      ? GenerateSubTree_Response.fromPartial(object.generate_sub_tree)
      : undefined;
    message.get_analysis_node = (object.get_analysis_node !== undefined && object.get_analysis_node !== null)
      ? GetAnalysisNode_Response.fromPartial(object.get_analysis_node)
      : undefined;
    message.save_commentary = (object.save_commentary !== undefined && object.save_commentary !== null)
      ? SaveCommentary_Response.fromPartial(object.save_commentary)
      : undefined;
    message.delete_commentary = (object.delete_commentary !== undefined && object.delete_commentary !== null)
      ? DeleteCommentary_Response.fromPartial(object.delete_commentary)
      : undefined;
    message.update_tree_header = (object.update_tree_header !== undefined && object.update_tree_header !== null)
      ? UpdateTreeHeader_Response.fromPartial(object.update_tree_header)
      : undefined;
    message.set_commentary = (object.set_commentary !== undefined && object.set_commentary !== null)
      ? SetCommentary_Response.fromPartial(object.set_commentary)
      : undefined;
    message.update_node = (object.update_node !== undefined && object.update_node !== null)
      ? UpdateNode_Response.fromPartial(object.update_node)
      : undefined;
    message.set_insights = (object.set_insights !== undefined && object.set_insights !== null)
      ? SetInsights_Response.fromPartial(object.set_insights)
      : undefined;
    message.generate_commentary = (object.generate_commentary !== undefined && object.generate_commentary !== null)
      ? GenerateCommentary_Response.fromPartial(object.generate_commentary)
      : undefined;
    return message;
  },
};

function createBaseGenerateTree(): GenerateTree {
  return {};
}

export const GenerateTree: MessageFns<GenerateTree> = {
  encode(_: GenerateTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GenerateTree {
    return {};
  },

  toJSON(_: GenerateTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateTree>, I>>(base?: I): GenerateTree {
    return GenerateTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateTree>, I>>(_: I): GenerateTree {
    const message = createBaseGenerateTree();
    return message;
  },
};

function createBaseGenerateTree_Request(): GenerateTree_Request {
  return {
    metricId: undefined,
    tree_name: undefined,
    benchmark: [],
    context: [],
    exclude_edges: [],
    diagnostic_plan: undefined,
    analysis_plan: undefined,
  };
}

export const GenerateTree_Request: MessageFns<GenerateTree_Request> = {
  encode(message: GenerateTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metricId !== undefined) {
      writer.uint32(10).string(message.metricId);
    }
    if (message.tree_name !== undefined) {
      writer.uint32(18).string(message.tree_name);
    }
    for (const v of message.benchmark) {
      BenchmarkProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.context) {
      FilterProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.exclude_edges) {
      Header.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.diagnostic_plan !== undefined) {
      AnalysisTreeGenerationRules_NodeInheritanceRules.encode(message.diagnostic_plan, writer.uint32(50).fork()).join();
    }
    if (message.analysis_plan !== undefined) {
      AnalysisPlanProto.encode(message.analysis_plan, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.benchmark.push(BenchmarkProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.context.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exclude_edges.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.diagnostic_plan = AnalysisTreeGenerationRules_NodeInheritanceRules.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.analysis_plan = AnalysisPlanProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateTree_Request {
    return {
      metricId: isSet(object.metricId) ? globalThis.String(object.metricId) : undefined,
      tree_name: isSet(object.tree_name) ? globalThis.String(object.tree_name) : undefined,
      benchmark: globalThis.Array.isArray(object?.benchmark)
        ? object.benchmark.map((e: any) => BenchmarkProto.fromJSON(e))
        : [],
      context: globalThis.Array.isArray(object?.context) ? object.context.map((e: any) => FilterProto.fromJSON(e)) : [],
      exclude_edges: globalThis.Array.isArray(object?.exclude_edges)
        ? object.exclude_edges.map((e: any) => Header.fromJSON(e))
        : [],
      diagnostic_plan: isSet(object.diagnostic_plan)
        ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromJSON(object.diagnostic_plan)
        : undefined,
      analysis_plan: isSet(object.analysis_plan) ? AnalysisPlanProto.fromJSON(object.analysis_plan) : undefined,
    };
  },

  toJSON(message: GenerateTree_Request): unknown {
    const obj: any = {};
    if (message.metricId !== undefined) {
      obj.metricId = message.metricId;
    }
    if (message.tree_name !== undefined) {
      obj.tree_name = message.tree_name;
    }
    if (message.benchmark?.length) {
      obj.benchmark = message.benchmark.map((e) => BenchmarkProto.toJSON(e));
    }
    if (message.context?.length) {
      obj.context = message.context.map((e) => FilterProto.toJSON(e));
    }
    if (message.exclude_edges?.length) {
      obj.exclude_edges = message.exclude_edges.map((e) => Header.toJSON(e));
    }
    if (message.diagnostic_plan !== undefined) {
      obj.diagnostic_plan = AnalysisTreeGenerationRules_NodeInheritanceRules.toJSON(message.diagnostic_plan);
    }
    if (message.analysis_plan !== undefined) {
      obj.analysis_plan = AnalysisPlanProto.toJSON(message.analysis_plan);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateTree_Request>, I>>(base?: I): GenerateTree_Request {
    return GenerateTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateTree_Request>, I>>(object: I): GenerateTree_Request {
    const message = createBaseGenerateTree_Request();
    message.metricId = object.metricId ?? undefined;
    message.tree_name = object.tree_name ?? undefined;
    message.benchmark = object.benchmark?.map((e) => BenchmarkProto.fromPartial(e)) || [];
    message.context = object.context?.map((e) => FilterProto.fromPartial(e)) || [];
    message.exclude_edges = object.exclude_edges?.map((e) => Header.fromPartial(e)) || [];
    message.diagnostic_plan = (object.diagnostic_plan !== undefined && object.diagnostic_plan !== null)
      ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromPartial(object.diagnostic_plan)
      : undefined;
    message.analysis_plan = (object.analysis_plan !== undefined && object.analysis_plan !== null)
      ? AnalysisPlanProto.fromPartial(object.analysis_plan)
      : undefined;
    return message;
  },
};

function createBaseGenerateTree_Response(): GenerateTree_Response {
  return { tree: undefined, node_metric_map: [] };
}

export const GenerateTree_Response: MessageFns<GenerateTree_Response> = {
  encode(message: GenerateTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree !== undefined) {
      AnalysisTreeProto.encode(message.tree, writer.uint32(10).fork()).join();
    }
    for (const v of message.node_metric_map) {
      TreeNodeMetricProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree = AnalysisTreeProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.node_metric_map.push(TreeNodeMetricProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateTree_Response {
    return {
      tree: isSet(object.tree) ? AnalysisTreeProto.fromJSON(object.tree) : undefined,
      node_metric_map: globalThis.Array.isArray(object?.node_metric_map)
        ? object.node_metric_map.map((e: any) => TreeNodeMetricProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenerateTree_Response): unknown {
    const obj: any = {};
    if (message.tree !== undefined) {
      obj.tree = AnalysisTreeProto.toJSON(message.tree);
    }
    if (message.node_metric_map?.length) {
      obj.node_metric_map = message.node_metric_map.map((e) => TreeNodeMetricProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateTree_Response>, I>>(base?: I): GenerateTree_Response {
    return GenerateTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateTree_Response>, I>>(object: I): GenerateTree_Response {
    const message = createBaseGenerateTree_Response();
    message.tree = (object.tree !== undefined && object.tree !== null)
      ? AnalysisTreeProto.fromPartial(object.tree)
      : undefined;
    message.node_metric_map = object.node_metric_map?.map((e) => TreeNodeMetricProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLoadTree(): LoadTree {
  return {};
}

export const LoadTree: MessageFns<LoadTree> = {
  encode(_: LoadTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LoadTree {
    return {};
  },

  toJSON(_: LoadTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTree>, I>>(base?: I): LoadTree {
    return LoadTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTree>, I>>(_: I): LoadTree {
    const message = createBaseLoadTree();
    return message;
  },
};

function createBaseLoadTree_Request(): LoadTree_Request {
  return { tree_id: undefined };
}

export const LoadTree_Request: MessageFns<LoadTree_Request> = {
  encode(message: LoadTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree_id !== undefined) {
      writer.uint32(10).string(message.tree_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadTree_Request {
    return { tree_id: isSet(object.tree_id) ? globalThis.String(object.tree_id) : undefined };
  },

  toJSON(message: LoadTree_Request): unknown {
    const obj: any = {};
    if (message.tree_id !== undefined) {
      obj.tree_id = message.tree_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTree_Request>, I>>(base?: I): LoadTree_Request {
    return LoadTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTree_Request>, I>>(object: I): LoadTree_Request {
    const message = createBaseLoadTree_Request();
    message.tree_id = object.tree_id ?? undefined;
    return message;
  },
};

function createBaseLoadTree_Response(): LoadTree_Response {
  return { tree: undefined, node_metric_map: [] };
}

export const LoadTree_Response: MessageFns<LoadTree_Response> = {
  encode(message: LoadTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree !== undefined) {
      AnalysisTreeProto.encode(message.tree, writer.uint32(10).fork()).join();
    }
    for (const v of message.node_metric_map) {
      TreeNodeMetricProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree = AnalysisTreeProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.node_metric_map.push(TreeNodeMetricProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadTree_Response {
    return {
      tree: isSet(object.tree) ? AnalysisTreeProto.fromJSON(object.tree) : undefined,
      node_metric_map: globalThis.Array.isArray(object?.node_metric_map)
        ? object.node_metric_map.map((e: any) => TreeNodeMetricProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LoadTree_Response): unknown {
    const obj: any = {};
    if (message.tree !== undefined) {
      obj.tree = AnalysisTreeProto.toJSON(message.tree);
    }
    if (message.node_metric_map?.length) {
      obj.node_metric_map = message.node_metric_map.map((e) => TreeNodeMetricProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTree_Response>, I>>(base?: I): LoadTree_Response {
    return LoadTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTree_Response>, I>>(object: I): LoadTree_Response {
    const message = createBaseLoadTree_Response();
    message.tree = (object.tree !== undefined && object.tree !== null)
      ? AnalysisTreeProto.fromPartial(object.tree)
      : undefined;
    message.node_metric_map = object.node_metric_map?.map((e) => TreeNodeMetricProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetTree(): GetTree {
  return {};
}

export const GetTree: MessageFns<GetTree> = {
  encode(_: GetTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetTree {
    return {};
  },

  toJSON(_: GetTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTree>, I>>(base?: I): GetTree {
    return GetTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTree>, I>>(_: I): GetTree {
    const message = createBaseGetTree();
    return message;
  },
};

function createBaseGetTree_Request(): GetTree_Request {
  return { include_nodes: undefined, include_commentary: undefined, include_node_metric_map: undefined };
}

export const GetTree_Request: MessageFns<GetTree_Request> = {
  encode(message: GetTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.include_nodes !== undefined) {
      writer.uint32(8).bool(message.include_nodes);
    }
    if (message.include_commentary !== undefined) {
      writer.uint32(16).bool(message.include_commentary);
    }
    if (message.include_node_metric_map !== undefined) {
      writer.uint32(24).bool(message.include_node_metric_map);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.include_nodes = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.include_commentary = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.include_node_metric_map = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTree_Request {
    return {
      include_nodes: isSet(object.include_nodes) ? globalThis.Boolean(object.include_nodes) : undefined,
      include_commentary: isSet(object.include_commentary) ? globalThis.Boolean(object.include_commentary) : undefined,
      include_node_metric_map: isSet(object.include_node_metric_map)
        ? globalThis.Boolean(object.include_node_metric_map)
        : undefined,
    };
  },

  toJSON(message: GetTree_Request): unknown {
    const obj: any = {};
    if (message.include_nodes !== undefined) {
      obj.include_nodes = message.include_nodes;
    }
    if (message.include_commentary !== undefined) {
      obj.include_commentary = message.include_commentary;
    }
    if (message.include_node_metric_map !== undefined) {
      obj.include_node_metric_map = message.include_node_metric_map;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTree_Request>, I>>(base?: I): GetTree_Request {
    return GetTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTree_Request>, I>>(object: I): GetTree_Request {
    const message = createBaseGetTree_Request();
    message.include_nodes = object.include_nodes ?? undefined;
    message.include_commentary = object.include_commentary ?? undefined;
    message.include_node_metric_map = object.include_node_metric_map ?? undefined;
    return message;
  },
};

function createBaseGetTree_Response(): GetTree_Response {
  return { tree: undefined, node_metric_map: [] };
}

export const GetTree_Response: MessageFns<GetTree_Response> = {
  encode(message: GetTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree !== undefined) {
      AnalysisTreeProto.encode(message.tree, writer.uint32(10).fork()).join();
    }
    for (const v of message.node_metric_map) {
      TreeNodeMetricProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree = AnalysisTreeProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.node_metric_map.push(TreeNodeMetricProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTree_Response {
    return {
      tree: isSet(object.tree) ? AnalysisTreeProto.fromJSON(object.tree) : undefined,
      node_metric_map: globalThis.Array.isArray(object?.node_metric_map)
        ? object.node_metric_map.map((e: any) => TreeNodeMetricProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTree_Response): unknown {
    const obj: any = {};
    if (message.tree !== undefined) {
      obj.tree = AnalysisTreeProto.toJSON(message.tree);
    }
    if (message.node_metric_map?.length) {
      obj.node_metric_map = message.node_metric_map.map((e) => TreeNodeMetricProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTree_Response>, I>>(base?: I): GetTree_Response {
    return GetTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTree_Response>, I>>(object: I): GetTree_Response {
    const message = createBaseGetTree_Response();
    message.tree = (object.tree !== undefined && object.tree !== null)
      ? AnalysisTreeProto.fromPartial(object.tree)
      : undefined;
    message.node_metric_map = object.node_metric_map?.map((e) => TreeNodeMetricProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSaveTree(): SaveTree {
  return {};
}

export const SaveTree: MessageFns<SaveTree> = {
  encode(_: SaveTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SaveTree {
    return {};
  },

  toJSON(_: SaveTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveTree>, I>>(base?: I): SaveTree {
    return SaveTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveTree>, I>>(_: I): SaveTree {
    const message = createBaseSaveTree();
    return message;
  },
};

function createBaseSaveTree_Request(): SaveTree_Request {
  return {};
}

export const SaveTree_Request: MessageFns<SaveTree_Request> = {
  encode(_: SaveTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SaveTree_Request {
    return {};
  },

  toJSON(_: SaveTree_Request): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveTree_Request>, I>>(base?: I): SaveTree_Request {
    return SaveTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveTree_Request>, I>>(_: I): SaveTree_Request {
    const message = createBaseSaveTree_Request();
    return message;
  },
};

function createBaseSaveTree_Response(): SaveTree_Response {
  return {};
}

export const SaveTree_Response: MessageFns<SaveTree_Response> = {
  encode(_: SaveTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SaveTree_Response {
    return {};
  },

  toJSON(_: SaveTree_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveTree_Response>, I>>(base?: I): SaveTree_Response {
    return SaveTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveTree_Response>, I>>(_: I): SaveTree_Response {
    const message = createBaseSaveTree_Response();
    return message;
  },
};

function createBaseGenerateSubTree(): GenerateSubTree {
  return {};
}

export const GenerateSubTree: MessageFns<GenerateSubTree> = {
  encode(_: GenerateSubTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateSubTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateSubTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GenerateSubTree {
    return {};
  },

  toJSON(_: GenerateSubTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateSubTree>, I>>(base?: I): GenerateSubTree {
    return GenerateSubTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateSubTree>, I>>(_: I): GenerateSubTree {
    const message = createBaseGenerateSubTree();
    return message;
  },
};

function createBaseGenerateSubTree_Request(): GenerateSubTree_Request {
  return {
    parent_node_id: undefined,
    edge_id: undefined,
    row_index: undefined,
    benchmark: undefined,
    create_root_node_only: undefined,
    child_step_edits: [],
  };
}

export const GenerateSubTree_Request: MessageFns<GenerateSubTree_Request> = {
  encode(message: GenerateSubTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent_node_id !== undefined) {
      writer.uint32(10).string(message.parent_node_id);
    }
    if (message.edge_id !== undefined) {
      writer.uint32(18).string(message.edge_id);
    }
    if (message.row_index !== undefined) {
      writer.uint32(24).int32(message.row_index);
    }
    if (message.benchmark !== undefined) {
      BenchmarkProto.encode(message.benchmark, writer.uint32(34).fork()).join();
    }
    if (message.create_root_node_only !== undefined) {
      writer.uint32(40).bool(message.create_root_node_only);
    }
    for (const v of message.child_step_edits) {
      ObservationEditProto.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateSubTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateSubTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parent_node_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edge_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.row_index = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.benchmark = BenchmarkProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.create_root_node_only = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.child_step_edits.push(ObservationEditProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateSubTree_Request {
    return {
      parent_node_id: isSet(object.parent_node_id) ? globalThis.String(object.parent_node_id) : undefined,
      edge_id: isSet(object.edge_id) ? globalThis.String(object.edge_id) : undefined,
      row_index: isSet(object.row_index) ? globalThis.Number(object.row_index) : undefined,
      benchmark: isSet(object.benchmark) ? BenchmarkProto.fromJSON(object.benchmark) : undefined,
      create_root_node_only: isSet(object.create_root_node_only)
        ? globalThis.Boolean(object.create_root_node_only)
        : undefined,
      child_step_edits: globalThis.Array.isArray(object?.child_step_edits)
        ? object.child_step_edits.map((e: any) => ObservationEditProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenerateSubTree_Request): unknown {
    const obj: any = {};
    if (message.parent_node_id !== undefined) {
      obj.parent_node_id = message.parent_node_id;
    }
    if (message.edge_id !== undefined) {
      obj.edge_id = message.edge_id;
    }
    if (message.row_index !== undefined) {
      obj.row_index = Math.round(message.row_index);
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = BenchmarkProto.toJSON(message.benchmark);
    }
    if (message.create_root_node_only !== undefined) {
      obj.create_root_node_only = message.create_root_node_only;
    }
    if (message.child_step_edits?.length) {
      obj.child_step_edits = message.child_step_edits.map((e) => ObservationEditProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateSubTree_Request>, I>>(base?: I): GenerateSubTree_Request {
    return GenerateSubTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateSubTree_Request>, I>>(object: I): GenerateSubTree_Request {
    const message = createBaseGenerateSubTree_Request();
    message.parent_node_id = object.parent_node_id ?? undefined;
    message.edge_id = object.edge_id ?? undefined;
    message.row_index = object.row_index ?? undefined;
    message.benchmark = (object.benchmark !== undefined && object.benchmark !== null)
      ? BenchmarkProto.fromPartial(object.benchmark)
      : undefined;
    message.create_root_node_only = object.create_root_node_only ?? undefined;
    message.child_step_edits = object.child_step_edits?.map((e) => ObservationEditProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenerateSubTree_Response(): GenerateSubTree_Response {
  return {};
}

export const GenerateSubTree_Response: MessageFns<GenerateSubTree_Response> = {
  encode(_: GenerateSubTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateSubTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateSubTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GenerateSubTree_Response {
    return {};
  },

  toJSON(_: GenerateSubTree_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateSubTree_Response>, I>>(base?: I): GenerateSubTree_Response {
    return GenerateSubTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateSubTree_Response>, I>>(_: I): GenerateSubTree_Response {
    const message = createBaseGenerateSubTree_Response();
    return message;
  },
};

function createBaseGetAnalysisNode(): GetAnalysisNode {
  return {};
}

export const GetAnalysisNode: MessageFns<GetAnalysisNode> = {
  encode(_: GetAnalysisNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAnalysisNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAnalysisNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAnalysisNode {
    return {};
  },

  toJSON(_: GetAnalysisNode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAnalysisNode>, I>>(base?: I): GetAnalysisNode {
    return GetAnalysisNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAnalysisNode>, I>>(_: I): GetAnalysisNode {
    const message = createBaseGetAnalysisNode();
    return message;
  },
};

function createBaseGetAnalysisNode_Request(): GetAnalysisNode_Request {
  return { node_id: undefined, include_data: undefined, include_parent_kg_observation: undefined };
}

export const GetAnalysisNode_Request: MessageFns<GetAnalysisNode_Request> = {
  encode(message: GetAnalysisNode_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== undefined) {
      writer.uint32(10).string(message.node_id);
    }
    if (message.include_data !== undefined) {
      writer.uint32(16).bool(message.include_data);
    }
    if (message.include_parent_kg_observation !== undefined) {
      writer.uint32(24).bool(message.include_parent_kg_observation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAnalysisNode_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAnalysisNode_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.node_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.include_data = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.include_parent_kg_observation = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAnalysisNode_Request {
    return {
      node_id: isSet(object.node_id) ? globalThis.String(object.node_id) : undefined,
      include_data: isSet(object.include_data) ? globalThis.Boolean(object.include_data) : undefined,
      include_parent_kg_observation: isSet(object.include_parent_kg_observation)
        ? globalThis.Boolean(object.include_parent_kg_observation)
        : undefined,
    };
  },

  toJSON(message: GetAnalysisNode_Request): unknown {
    const obj: any = {};
    if (message.node_id !== undefined) {
      obj.node_id = message.node_id;
    }
    if (message.include_data !== undefined) {
      obj.include_data = message.include_data;
    }
    if (message.include_parent_kg_observation !== undefined) {
      obj.include_parent_kg_observation = message.include_parent_kg_observation;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAnalysisNode_Request>, I>>(base?: I): GetAnalysisNode_Request {
    return GetAnalysisNode_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAnalysisNode_Request>, I>>(object: I): GetAnalysisNode_Request {
    const message = createBaseGetAnalysisNode_Request();
    message.node_id = object.node_id ?? undefined;
    message.include_data = object.include_data ?? undefined;
    message.include_parent_kg_observation = object.include_parent_kg_observation ?? undefined;
    return message;
  },
};

function createBaseGetAnalysisNode_Response(): GetAnalysisNode_Response {
  return { analysis_node: undefined };
}

export const GetAnalysisNode_Response: MessageFns<GetAnalysisNode_Response> = {
  encode(message: GetAnalysisNode_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.analysis_node !== undefined) {
      AnalysisTreeNodeProto.encode(message.analysis_node, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAnalysisNode_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAnalysisNode_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.analysis_node = AnalysisTreeNodeProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAnalysisNode_Response {
    return {
      analysis_node: isSet(object.analysis_node) ? AnalysisTreeNodeProto.fromJSON(object.analysis_node) : undefined,
    };
  },

  toJSON(message: GetAnalysisNode_Response): unknown {
    const obj: any = {};
    if (message.analysis_node !== undefined) {
      obj.analysis_node = AnalysisTreeNodeProto.toJSON(message.analysis_node);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAnalysisNode_Response>, I>>(base?: I): GetAnalysisNode_Response {
    return GetAnalysisNode_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAnalysisNode_Response>, I>>(object: I): GetAnalysisNode_Response {
    const message = createBaseGetAnalysisNode_Response();
    message.analysis_node = (object.analysis_node !== undefined && object.analysis_node !== null)
      ? AnalysisTreeNodeProto.fromPartial(object.analysis_node)
      : undefined;
    return message;
  },
};

function createBaseSetCommentary(): SetCommentary {
  return {};
}

export const SetCommentary: MessageFns<SetCommentary> = {
  encode(_: SetCommentary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCommentary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCommentary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCommentary {
    return {};
  },

  toJSON(_: SetCommentary): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCommentary>, I>>(base?: I): SetCommentary {
    return SetCommentary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCommentary>, I>>(_: I): SetCommentary {
    const message = createBaseSetCommentary();
    return message;
  },
};

function createBaseSetCommentary_Request(): SetCommentary_Request {
  return { commentary: [] };
}

export const SetCommentary_Request: MessageFns<SetCommentary_Request> = {
  encode(message: SetCommentary_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.commentary) {
      CommentaryProto.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCommentary_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCommentary_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commentary.push(CommentaryProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCommentary_Request {
    return {
      commentary: globalThis.Array.isArray(object?.commentary)
        ? object.commentary.map((e: any) => CommentaryProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetCommentary_Request): unknown {
    const obj: any = {};
    if (message.commentary?.length) {
      obj.commentary = message.commentary.map((e) => CommentaryProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCommentary_Request>, I>>(base?: I): SetCommentary_Request {
    return SetCommentary_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCommentary_Request>, I>>(object: I): SetCommentary_Request {
    const message = createBaseSetCommentary_Request();
    message.commentary = object.commentary?.map((e) => CommentaryProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetCommentary_Response(): SetCommentary_Response {
  return {};
}

export const SetCommentary_Response: MessageFns<SetCommentary_Response> = {
  encode(_: SetCommentary_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCommentary_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCommentary_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCommentary_Response {
    return {};
  },

  toJSON(_: SetCommentary_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCommentary_Response>, I>>(base?: I): SetCommentary_Response {
    return SetCommentary_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCommentary_Response>, I>>(_: I): SetCommentary_Response {
    const message = createBaseSetCommentary_Response();
    return message;
  },
};

function createBaseSaveCommentary(): SaveCommentary {
  return {};
}

export const SaveCommentary: MessageFns<SaveCommentary> = {
  encode(_: SaveCommentary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveCommentary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveCommentary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SaveCommentary {
    return {};
  },

  toJSON(_: SaveCommentary): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveCommentary>, I>>(base?: I): SaveCommentary {
    return SaveCommentary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveCommentary>, I>>(_: I): SaveCommentary {
    const message = createBaseSaveCommentary();
    return message;
  },
};

function createBaseSaveCommentary_Request(): SaveCommentary_Request {
  return { conversation_id: undefined, edited_commentary: undefined };
}

export const SaveCommentary_Request: MessageFns<SaveCommentary_Request> = {
  encode(message: SaveCommentary_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.conversation_id !== undefined) {
      writer.uint32(10).string(message.conversation_id);
    }
    if (message.edited_commentary !== undefined) {
      writer.uint32(18).string(message.edited_commentary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveCommentary_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveCommentary_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.conversation_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edited_commentary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SaveCommentary_Request {
    return {
      conversation_id: isSet(object.conversation_id) ? globalThis.String(object.conversation_id) : undefined,
      edited_commentary: isSet(object.edited_commentary) ? globalThis.String(object.edited_commentary) : undefined,
    };
  },

  toJSON(message: SaveCommentary_Request): unknown {
    const obj: any = {};
    if (message.conversation_id !== undefined) {
      obj.conversation_id = message.conversation_id;
    }
    if (message.edited_commentary !== undefined) {
      obj.edited_commentary = message.edited_commentary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveCommentary_Request>, I>>(base?: I): SaveCommentary_Request {
    return SaveCommentary_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveCommentary_Request>, I>>(object: I): SaveCommentary_Request {
    const message = createBaseSaveCommentary_Request();
    message.conversation_id = object.conversation_id ?? undefined;
    message.edited_commentary = object.edited_commentary ?? undefined;
    return message;
  },
};

function createBaseSaveCommentary_Response(): SaveCommentary_Response {
  return {};
}

export const SaveCommentary_Response: MessageFns<SaveCommentary_Response> = {
  encode(_: SaveCommentary_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveCommentary_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveCommentary_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SaveCommentary_Response {
    return {};
  },

  toJSON(_: SaveCommentary_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveCommentary_Response>, I>>(base?: I): SaveCommentary_Response {
    return SaveCommentary_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveCommentary_Response>, I>>(_: I): SaveCommentary_Response {
    const message = createBaseSaveCommentary_Response();
    return message;
  },
};

function createBaseDeleteCommentary(): DeleteCommentary {
  return {};
}

export const DeleteCommentary: MessageFns<DeleteCommentary> = {
  encode(_: DeleteCommentary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCommentary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCommentary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteCommentary {
    return {};
  },

  toJSON(_: DeleteCommentary): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCommentary>, I>>(base?: I): DeleteCommentary {
    return DeleteCommentary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCommentary>, I>>(_: I): DeleteCommentary {
    const message = createBaseDeleteCommentary();
    return message;
  },
};

function createBaseDeleteCommentary_Request(): DeleteCommentary_Request {
  return { conversation_id: undefined, remove_from_session: undefined };
}

export const DeleteCommentary_Request: MessageFns<DeleteCommentary_Request> = {
  encode(message: DeleteCommentary_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.conversation_id !== undefined) {
      writer.uint32(10).string(message.conversation_id);
    }
    if (message.remove_from_session !== undefined) {
      writer.uint32(16).bool(message.remove_from_session);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCommentary_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCommentary_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.conversation_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.remove_from_session = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCommentary_Request {
    return {
      conversation_id: isSet(object.conversation_id) ? globalThis.String(object.conversation_id) : undefined,
      remove_from_session: isSet(object.remove_from_session)
        ? globalThis.Boolean(object.remove_from_session)
        : undefined,
    };
  },

  toJSON(message: DeleteCommentary_Request): unknown {
    const obj: any = {};
    if (message.conversation_id !== undefined) {
      obj.conversation_id = message.conversation_id;
    }
    if (message.remove_from_session !== undefined) {
      obj.remove_from_session = message.remove_from_session;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCommentary_Request>, I>>(base?: I): DeleteCommentary_Request {
    return DeleteCommentary_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCommentary_Request>, I>>(object: I): DeleteCommentary_Request {
    const message = createBaseDeleteCommentary_Request();
    message.conversation_id = object.conversation_id ?? undefined;
    message.remove_from_session = object.remove_from_session ?? undefined;
    return message;
  },
};

function createBaseDeleteCommentary_Response(): DeleteCommentary_Response {
  return {};
}

export const DeleteCommentary_Response: MessageFns<DeleteCommentary_Response> = {
  encode(_: DeleteCommentary_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCommentary_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCommentary_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteCommentary_Response {
    return {};
  },

  toJSON(_: DeleteCommentary_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCommentary_Response>, I>>(base?: I): DeleteCommentary_Response {
    return DeleteCommentary_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCommentary_Response>, I>>(_: I): DeleteCommentary_Response {
    const message = createBaseDeleteCommentary_Response();
    return message;
  },
};

function createBaseUpdateTreeHeader(): UpdateTreeHeader {
  return {};
}

export const UpdateTreeHeader: MessageFns<UpdateTreeHeader> = {
  encode(_: UpdateTreeHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTreeHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTreeHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateTreeHeader {
    return {};
  },

  toJSON(_: UpdateTreeHeader): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTreeHeader>, I>>(base?: I): UpdateTreeHeader {
    return UpdateTreeHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTreeHeader>, I>>(_: I): UpdateTreeHeader {
    const message = createBaseUpdateTreeHeader();
    return message;
  },
};

function createBaseUpdateTreeHeader_Request(): UpdateTreeHeader_Request {
  return { updated_name: undefined, updated_description: undefined };
}

export const UpdateTreeHeader_Request: MessageFns<UpdateTreeHeader_Request> = {
  encode(message: UpdateTreeHeader_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updated_name !== undefined) {
      writer.uint32(10).string(message.updated_name);
    }
    if (message.updated_description !== undefined) {
      writer.uint32(18).string(message.updated_description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTreeHeader_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTreeHeader_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updated_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updated_description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTreeHeader_Request {
    return {
      updated_name: isSet(object.updated_name) ? globalThis.String(object.updated_name) : undefined,
      updated_description: isSet(object.updated_description)
        ? globalThis.String(object.updated_description)
        : undefined,
    };
  },

  toJSON(message: UpdateTreeHeader_Request): unknown {
    const obj: any = {};
    if (message.updated_name !== undefined) {
      obj.updated_name = message.updated_name;
    }
    if (message.updated_description !== undefined) {
      obj.updated_description = message.updated_description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTreeHeader_Request>, I>>(base?: I): UpdateTreeHeader_Request {
    return UpdateTreeHeader_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTreeHeader_Request>, I>>(object: I): UpdateTreeHeader_Request {
    const message = createBaseUpdateTreeHeader_Request();
    message.updated_name = object.updated_name ?? undefined;
    message.updated_description = object.updated_description ?? undefined;
    return message;
  },
};

function createBaseUpdateTreeHeader_Response(): UpdateTreeHeader_Response {
  return {};
}

export const UpdateTreeHeader_Response: MessageFns<UpdateTreeHeader_Response> = {
  encode(_: UpdateTreeHeader_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTreeHeader_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTreeHeader_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateTreeHeader_Response {
    return {};
  },

  toJSON(_: UpdateTreeHeader_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTreeHeader_Response>, I>>(base?: I): UpdateTreeHeader_Response {
    return UpdateTreeHeader_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTreeHeader_Response>, I>>(_: I): UpdateTreeHeader_Response {
    const message = createBaseUpdateTreeHeader_Response();
    return message;
  },
};

function createBaseUpdateNode(): UpdateNode {
  return {};
}

export const UpdateNode: MessageFns<UpdateNode> = {
  encode(_: UpdateNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateNode {
    return {};
  },

  toJSON(_: UpdateNode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNode>, I>>(base?: I): UpdateNode {
    return UpdateNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNode>, I>>(_: I): UpdateNode {
    const message = createBaseUpdateNode();
    return message;
  },
};

function createBaseUpdateNode_Request(): UpdateNode_Request {
  return { node_id: undefined, new_node_label: undefined };
}

export const UpdateNode_Request: MessageFns<UpdateNode_Request> = {
  encode(message: UpdateNode_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== undefined) {
      writer.uint32(10).string(message.node_id);
    }
    if (message.new_node_label !== undefined) {
      writer.uint32(18).string(message.new_node_label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNode_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNode_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.node_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.new_node_label = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNode_Request {
    return {
      node_id: isSet(object.node_id) ? globalThis.String(object.node_id) : undefined,
      new_node_label: isSet(object.new_node_label) ? globalThis.String(object.new_node_label) : undefined,
    };
  },

  toJSON(message: UpdateNode_Request): unknown {
    const obj: any = {};
    if (message.node_id !== undefined) {
      obj.node_id = message.node_id;
    }
    if (message.new_node_label !== undefined) {
      obj.new_node_label = message.new_node_label;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNode_Request>, I>>(base?: I): UpdateNode_Request {
    return UpdateNode_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNode_Request>, I>>(object: I): UpdateNode_Request {
    const message = createBaseUpdateNode_Request();
    message.node_id = object.node_id ?? undefined;
    message.new_node_label = object.new_node_label ?? undefined;
    return message;
  },
};

function createBaseUpdateNode_Response(): UpdateNode_Response {
  return {};
}

export const UpdateNode_Response: MessageFns<UpdateNode_Response> = {
  encode(_: UpdateNode_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNode_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNode_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateNode_Response {
    return {};
  },

  toJSON(_: UpdateNode_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNode_Response>, I>>(base?: I): UpdateNode_Response {
    return UpdateNode_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNode_Response>, I>>(_: I): UpdateNode_Response {
    const message = createBaseUpdateNode_Response();
    return message;
  },
};

function createBaseSetInsights(): SetInsights {
  return {};
}

export const SetInsights: MessageFns<SetInsights> = {
  encode(_: SetInsights, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetInsights {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetInsights();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetInsights {
    return {};
  },

  toJSON(_: SetInsights): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetInsights>, I>>(base?: I): SetInsights {
    return SetInsights.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetInsights>, I>>(_: I): SetInsights {
    const message = createBaseSetInsights();
    return message;
  },
};

function createBaseSetInsights_Request(): SetInsights_Request {
  return { insights: [] };
}

export const SetInsights_Request: MessageFns<SetInsights_Request> = {
  encode(message: SetInsights_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.insights) {
      InsightsProto.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetInsights_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetInsights_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.insights.push(InsightsProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetInsights_Request {
    return {
      insights: globalThis.Array.isArray(object?.insights)
        ? object.insights.map((e: any) => InsightsProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetInsights_Request): unknown {
    const obj: any = {};
    if (message.insights?.length) {
      obj.insights = message.insights.map((e) => InsightsProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetInsights_Request>, I>>(base?: I): SetInsights_Request {
    return SetInsights_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetInsights_Request>, I>>(object: I): SetInsights_Request {
    const message = createBaseSetInsights_Request();
    message.insights = object.insights?.map((e) => InsightsProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetInsights_Response(): SetInsights_Response {
  return {};
}

export const SetInsights_Response: MessageFns<SetInsights_Response> = {
  encode(_: SetInsights_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetInsights_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetInsights_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetInsights_Response {
    return {};
  },

  toJSON(_: SetInsights_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetInsights_Response>, I>>(base?: I): SetInsights_Response {
    return SetInsights_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetInsights_Response>, I>>(_: I): SetInsights_Response {
    const message = createBaseSetInsights_Response();
    return message;
  },
};

function createBaseStatefulTisaRequest(): StatefulTisaRequest {
  return {
    type: undefined,
    add_trees: undefined,
    remove_trees: undefined,
    get_tisa_state: undefined,
    load_trees: undefined,
  };
}

export const StatefulTisaRequest: MessageFns<StatefulTisaRequest> = {
  encode(message: StatefulTisaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.add_trees !== undefined) {
      AddTrees_Request.encode(message.add_trees, writer.uint32(18).fork()).join();
    }
    if (message.remove_trees !== undefined) {
      RemoveTrees_Request.encode(message.remove_trees, writer.uint32(26).fork()).join();
    }
    if (message.get_tisa_state !== undefined) {
      GetTisaState_Request.encode(message.get_tisa_state, writer.uint32(34).fork()).join();
    }
    if (message.load_trees !== undefined) {
      LoadTrees_Request.encode(message.load_trees, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulTisaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulTisaRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.add_trees = AddTrees_Request.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.remove_trees = RemoveTrees_Request.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.get_tisa_state = GetTisaState_Request.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.load_trees = LoadTrees_Request.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulTisaRequest {
    return {
      type: isSet(object.type) ? tisaRequestTypeFromJSON(object.type) : undefined,
      add_trees: isSet(object.add_trees) ? AddTrees_Request.fromJSON(object.add_trees) : undefined,
      remove_trees: isSet(object.remove_trees) ? RemoveTrees_Request.fromJSON(object.remove_trees) : undefined,
      get_tisa_state: isSet(object.get_tisa_state) ? GetTisaState_Request.fromJSON(object.get_tisa_state) : undefined,
      load_trees: isSet(object.load_trees) ? LoadTrees_Request.fromJSON(object.load_trees) : undefined,
    };
  },

  toJSON(message: StatefulTisaRequest): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = tisaRequestTypeToJSON(message.type);
    }
    if (message.add_trees !== undefined) {
      obj.add_trees = AddTrees_Request.toJSON(message.add_trees);
    }
    if (message.remove_trees !== undefined) {
      obj.remove_trees = RemoveTrees_Request.toJSON(message.remove_trees);
    }
    if (message.get_tisa_state !== undefined) {
      obj.get_tisa_state = GetTisaState_Request.toJSON(message.get_tisa_state);
    }
    if (message.load_trees !== undefined) {
      obj.load_trees = LoadTrees_Request.toJSON(message.load_trees);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulTisaRequest>, I>>(base?: I): StatefulTisaRequest {
    return StatefulTisaRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulTisaRequest>, I>>(object: I): StatefulTisaRequest {
    const message = createBaseStatefulTisaRequest();
    message.type = object.type ?? undefined;
    message.add_trees = (object.add_trees !== undefined && object.add_trees !== null)
      ? AddTrees_Request.fromPartial(object.add_trees)
      : undefined;
    message.remove_trees = (object.remove_trees !== undefined && object.remove_trees !== null)
      ? RemoveTrees_Request.fromPartial(object.remove_trees)
      : undefined;
    message.get_tisa_state = (object.get_tisa_state !== undefined && object.get_tisa_state !== null)
      ? GetTisaState_Request.fromPartial(object.get_tisa_state)
      : undefined;
    message.load_trees = (object.load_trees !== undefined && object.load_trees !== null)
      ? LoadTrees_Request.fromPartial(object.load_trees)
      : undefined;
    return message;
  },
};

function createBaseStatefulTisaResponse(): StatefulTisaResponse {
  return {
    type: undefined,
    add_trees: undefined,
    remove_trees: undefined,
    get_tisa_state: undefined,
    load_trees: undefined,
  };
}

export const StatefulTisaResponse: MessageFns<StatefulTisaResponse> = {
  encode(message: StatefulTisaResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.add_trees !== undefined) {
      AddTrees_Response.encode(message.add_trees, writer.uint32(18).fork()).join();
    }
    if (message.remove_trees !== undefined) {
      RemoveTrees_Response.encode(message.remove_trees, writer.uint32(26).fork()).join();
    }
    if (message.get_tisa_state !== undefined) {
      GetTisaState_Response.encode(message.get_tisa_state, writer.uint32(34).fork()).join();
    }
    if (message.load_trees !== undefined) {
      LoadTrees_Response.encode(message.load_trees, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatefulTisaResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatefulTisaResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.add_trees = AddTrees_Response.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.remove_trees = RemoveTrees_Response.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.get_tisa_state = GetTisaState_Response.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.load_trees = LoadTrees_Response.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StatefulTisaResponse {
    return {
      type: isSet(object.type) ? tisaRequestTypeFromJSON(object.type) : undefined,
      add_trees: isSet(object.add_trees) ? AddTrees_Response.fromJSON(object.add_trees) : undefined,
      remove_trees: isSet(object.remove_trees) ? RemoveTrees_Response.fromJSON(object.remove_trees) : undefined,
      get_tisa_state: isSet(object.get_tisa_state) ? GetTisaState_Response.fromJSON(object.get_tisa_state) : undefined,
      load_trees: isSet(object.load_trees) ? LoadTrees_Response.fromJSON(object.load_trees) : undefined,
    };
  },

  toJSON(message: StatefulTisaResponse): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = tisaRequestTypeToJSON(message.type);
    }
    if (message.add_trees !== undefined) {
      obj.add_trees = AddTrees_Response.toJSON(message.add_trees);
    }
    if (message.remove_trees !== undefined) {
      obj.remove_trees = RemoveTrees_Response.toJSON(message.remove_trees);
    }
    if (message.get_tisa_state !== undefined) {
      obj.get_tisa_state = GetTisaState_Response.toJSON(message.get_tisa_state);
    }
    if (message.load_trees !== undefined) {
      obj.load_trees = LoadTrees_Response.toJSON(message.load_trees);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatefulTisaResponse>, I>>(base?: I): StatefulTisaResponse {
    return StatefulTisaResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatefulTisaResponse>, I>>(object: I): StatefulTisaResponse {
    const message = createBaseStatefulTisaResponse();
    message.type = object.type ?? undefined;
    message.add_trees = (object.add_trees !== undefined && object.add_trees !== null)
      ? AddTrees_Response.fromPartial(object.add_trees)
      : undefined;
    message.remove_trees = (object.remove_trees !== undefined && object.remove_trees !== null)
      ? RemoveTrees_Response.fromPartial(object.remove_trees)
      : undefined;
    message.get_tisa_state = (object.get_tisa_state !== undefined && object.get_tisa_state !== null)
      ? GetTisaState_Response.fromPartial(object.get_tisa_state)
      : undefined;
    message.load_trees = (object.load_trees !== undefined && object.load_trees !== null)
      ? LoadTrees_Response.fromPartial(object.load_trees)
      : undefined;
    return message;
  },
};

function createBaseAddTrees(): AddTrees {
  return {};
}

export const AddTrees: MessageFns<AddTrees> = {
  encode(_: AddTrees, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTrees {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTrees();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AddTrees {
    return {};
  },

  toJSON(_: AddTrees): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTrees>, I>>(base?: I): AddTrees {
    return AddTrees.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTrees>, I>>(_: I): AddTrees {
    const message = createBaseAddTrees();
    return message;
  },
};

function createBaseAddTrees_Request(): AddTrees_Request {
  return { tree_ids: [] };
}

export const AddTrees_Request: MessageFns<AddTrees_Request> = {
  encode(message: AddTrees_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tree_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTrees_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTrees_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddTrees_Request {
    return {
      tree_ids: globalThis.Array.isArray(object?.tree_ids) ? object.tree_ids.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: AddTrees_Request): unknown {
    const obj: any = {};
    if (message.tree_ids?.length) {
      obj.tree_ids = message.tree_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTrees_Request>, I>>(base?: I): AddTrees_Request {
    return AddTrees_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTrees_Request>, I>>(object: I): AddTrees_Request {
    const message = createBaseAddTrees_Request();
    message.tree_ids = object.tree_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseAddTrees_Response(): AddTrees_Response {
  return {};
}

export const AddTrees_Response: MessageFns<AddTrees_Response> = {
  encode(_: AddTrees_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTrees_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTrees_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AddTrees_Response {
    return {};
  },

  toJSON(_: AddTrees_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTrees_Response>, I>>(base?: I): AddTrees_Response {
    return AddTrees_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTrees_Response>, I>>(_: I): AddTrees_Response {
    const message = createBaseAddTrees_Response();
    return message;
  },
};

function createBaseRemoveTrees(): RemoveTrees {
  return {};
}

export const RemoveTrees: MessageFns<RemoveTrees> = {
  encode(_: RemoveTrees, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveTrees {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveTrees();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveTrees {
    return {};
  },

  toJSON(_: RemoveTrees): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveTrees>, I>>(base?: I): RemoveTrees {
    return RemoveTrees.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveTrees>, I>>(_: I): RemoveTrees {
    const message = createBaseRemoveTrees();
    return message;
  },
};

function createBaseRemoveTrees_Request(): RemoveTrees_Request {
  return { tree_ids: [] };
}

export const RemoveTrees_Request: MessageFns<RemoveTrees_Request> = {
  encode(message: RemoveTrees_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tree_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveTrees_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveTrees_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveTrees_Request {
    return {
      tree_ids: globalThis.Array.isArray(object?.tree_ids) ? object.tree_ids.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: RemoveTrees_Request): unknown {
    const obj: any = {};
    if (message.tree_ids?.length) {
      obj.tree_ids = message.tree_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveTrees_Request>, I>>(base?: I): RemoveTrees_Request {
    return RemoveTrees_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveTrees_Request>, I>>(object: I): RemoveTrees_Request {
    const message = createBaseRemoveTrees_Request();
    message.tree_ids = object.tree_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseRemoveTrees_Response(): RemoveTrees_Response {
  return {};
}

export const RemoveTrees_Response: MessageFns<RemoveTrees_Response> = {
  encode(_: RemoveTrees_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveTrees_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveTrees_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveTrees_Response {
    return {};
  },

  toJSON(_: RemoveTrees_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveTrees_Response>, I>>(base?: I): RemoveTrees_Response {
    return RemoveTrees_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveTrees_Response>, I>>(_: I): RemoveTrees_Response {
    const message = createBaseRemoveTrees_Response();
    return message;
  },
};

function createBaseGetTisaState(): GetTisaState {
  return {};
}

export const GetTisaState: MessageFns<GetTisaState> = {
  encode(_: GetTisaState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTisaState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTisaState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetTisaState {
    return {};
  },

  toJSON(_: GetTisaState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTisaState>, I>>(base?: I): GetTisaState {
    return GetTisaState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTisaState>, I>>(_: I): GetTisaState {
    const message = createBaseGetTisaState();
    return message;
  },
};

function createBaseGetTisaState_Request(): GetTisaState_Request {
  return { include_tree_sessions: undefined, include_trees: undefined };
}

export const GetTisaState_Request: MessageFns<GetTisaState_Request> = {
  encode(message: GetTisaState_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.include_tree_sessions !== undefined) {
      writer.uint32(8).bool(message.include_tree_sessions);
    }
    if (message.include_trees !== undefined) {
      writer.uint32(16).bool(message.include_trees);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTisaState_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTisaState_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.include_tree_sessions = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.include_trees = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTisaState_Request {
    return {
      include_tree_sessions: isSet(object.include_tree_sessions)
        ? globalThis.Boolean(object.include_tree_sessions)
        : undefined,
      include_trees: isSet(object.include_trees) ? globalThis.Boolean(object.include_trees) : undefined,
    };
  },

  toJSON(message: GetTisaState_Request): unknown {
    const obj: any = {};
    if (message.include_tree_sessions !== undefined) {
      obj.include_tree_sessions = message.include_tree_sessions;
    }
    if (message.include_trees !== undefined) {
      obj.include_trees = message.include_trees;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTisaState_Request>, I>>(base?: I): GetTisaState_Request {
    return GetTisaState_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTisaState_Request>, I>>(object: I): GetTisaState_Request {
    const message = createBaseGetTisaState_Request();
    message.include_tree_sessions = object.include_tree_sessions ?? undefined;
    message.include_trees = object.include_trees ?? undefined;
    return message;
  },
};

function createBaseGetTisaState_Response(): GetTisaState_Response {
  return { trees: [], tree_sessions: [] };
}

export const GetTisaState_Response: MessageFns<GetTisaState_Response> = {
  encode(message: GetTisaState_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trees) {
      AnalysisTreeProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.tree_sessions) {
      AnalysisTreeSessionKey.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTisaState_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTisaState_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trees.push(AnalysisTreeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_sessions.push(AnalysisTreeSessionKey.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTisaState_Response {
    return {
      trees: globalThis.Array.isArray(object?.trees) ? object.trees.map((e: any) => AnalysisTreeProto.fromJSON(e)) : [],
      tree_sessions: globalThis.Array.isArray(object?.tree_sessions)
        ? object.tree_sessions.map((e: any) => AnalysisTreeSessionKey.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTisaState_Response): unknown {
    const obj: any = {};
    if (message.trees?.length) {
      obj.trees = message.trees.map((e) => AnalysisTreeProto.toJSON(e));
    }
    if (message.tree_sessions?.length) {
      obj.tree_sessions = message.tree_sessions.map((e) => AnalysisTreeSessionKey.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTisaState_Response>, I>>(base?: I): GetTisaState_Response {
    return GetTisaState_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTisaState_Response>, I>>(object: I): GetTisaState_Response {
    const message = createBaseGetTisaState_Response();
    message.trees = object.trees?.map((e) => AnalysisTreeProto.fromPartial(e)) || [];
    message.tree_sessions = object.tree_sessions?.map((e) => AnalysisTreeSessionKey.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLoadTrees(): LoadTrees {
  return {};
}

export const LoadTrees: MessageFns<LoadTrees> = {
  encode(_: LoadTrees, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTrees {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTrees();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LoadTrees {
    return {};
  },

  toJSON(_: LoadTrees): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTrees>, I>>(base?: I): LoadTrees {
    return LoadTrees.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTrees>, I>>(_: I): LoadTrees {
    const message = createBaseLoadTrees();
    return message;
  },
};

function createBaseLoadTrees_Request(): LoadTrees_Request {
  return { tree_ids: [] };
}

export const LoadTrees_Request: MessageFns<LoadTrees_Request> = {
  encode(message: LoadTrees_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tree_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTrees_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTrees_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadTrees_Request {
    return {
      tree_ids: globalThis.Array.isArray(object?.tree_ids) ? object.tree_ids.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: LoadTrees_Request): unknown {
    const obj: any = {};
    if (message.tree_ids?.length) {
      obj.tree_ids = message.tree_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTrees_Request>, I>>(base?: I): LoadTrees_Request {
    return LoadTrees_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTrees_Request>, I>>(object: I): LoadTrees_Request {
    const message = createBaseLoadTrees_Request();
    message.tree_ids = object.tree_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseLoadTrees_Response(): LoadTrees_Response {
  return {};
}

export const LoadTrees_Response: MessageFns<LoadTrees_Response> = {
  encode(_: LoadTrees_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadTrees_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadTrees_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LoadTrees_Response {
    return {};
  },

  toJSON(_: LoadTrees_Response): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadTrees_Response>, I>>(base?: I): LoadTrees_Response {
    return LoadTrees_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadTrees_Response>, I>>(_: I): LoadTrees_Response {
    const message = createBaseLoadTrees_Response();
    return message;
  },
};

function createBaseGenerateCommentary(): GenerateCommentary {
  return {};
}

export const GenerateCommentary: MessageFns<GenerateCommentary> = {
  encode(_: GenerateCommentary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCommentary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCommentary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GenerateCommentary {
    return {};
  },

  toJSON(_: GenerateCommentary): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCommentary>, I>>(base?: I): GenerateCommentary {
    return GenerateCommentary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCommentary>, I>>(_: I): GenerateCommentary {
    const message = createBaseGenerateCommentary();
    return message;
  },
};

function createBaseGenerateCommentary_Request(): GenerateCommentary_Request {
  return { configuration: undefined };
}

export const GenerateCommentary_Request: MessageFns<GenerateCommentary_Request> = {
  encode(message: GenerateCommentary_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.configuration !== undefined) {
      CommentaryProto_CommentaryConfig.encode(message.configuration, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCommentary_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCommentary_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.configuration = CommentaryProto_CommentaryConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCommentary_Request {
    return {
      configuration: isSet(object.configuration)
        ? CommentaryProto_CommentaryConfig.fromJSON(object.configuration)
        : undefined,
    };
  },

  toJSON(message: GenerateCommentary_Request): unknown {
    const obj: any = {};
    if (message.configuration !== undefined) {
      obj.configuration = CommentaryProto_CommentaryConfig.toJSON(message.configuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCommentary_Request>, I>>(base?: I): GenerateCommentary_Request {
    return GenerateCommentary_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCommentary_Request>, I>>(object: I): GenerateCommentary_Request {
    const message = createBaseGenerateCommentary_Request();
    message.configuration = (object.configuration !== undefined && object.configuration !== null)
      ? CommentaryProto_CommentaryConfig.fromPartial(object.configuration)
      : undefined;
    return message;
  },
};

function createBaseGenerateCommentary_Response(): GenerateCommentary_Response {
  return { commentary: undefined };
}

export const GenerateCommentary_Response: MessageFns<GenerateCommentary_Response> = {
  encode(message: GenerateCommentary_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commentary !== undefined) {
      CommentaryProto.encode(message.commentary, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCommentary_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCommentary_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commentary = CommentaryProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCommentary_Response {
    return { commentary: isSet(object.commentary) ? CommentaryProto.fromJSON(object.commentary) : undefined };
  },

  toJSON(message: GenerateCommentary_Response): unknown {
    const obj: any = {};
    if (message.commentary !== undefined) {
      obj.commentary = CommentaryProto.toJSON(message.commentary);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCommentary_Response>, I>>(base?: I): GenerateCommentary_Response {
    return GenerateCommentary_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCommentary_Response>, I>>(object: I): GenerateCommentary_Response {
    const message = createBaseGenerateCommentary_Response();
    message.commentary = (object.commentary !== undefined && object.commentary !== null)
      ? CommentaryProto.fromPartial(object.commentary)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
